export default __webpack_public_path__ + "static/media/cloudera.3e0b2a98.svg";